import React from 'react';

const Footer = () => {
    return (
        <footer>
            <p className='bg-success text-light text-center fst-italic mt-5'>© Fairplay 2025. All rights reserved</p>
        </footer>
    );
};

export default Footer;